/**
 * Swiper
 * https://swiperjs.com/swiper-api
 *
 * DOMは下記のようにしておくこと
 * .swiper.js-swiper-xxx > .swiper-wrapper > .swiper-slide
 *
 * 左右navigationとpaginationのhtmlは下記のようなモディファイアをつけておくこと
 * .swiper-button-next.-xxx
 * .swiper-button-prev.-xxx
 * .swiper-pagination.-xxx
 *
 * xxxに入る値は、TRIGGER_SELECTORSの配列に入れる
 *
 */

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// Swiper初期化完了フラグ
let isSwiperInitialized = false;
//Swiper要素
//const $SWIPER_ELEMENTS = $('[class*=js-swiper-],[class*=swiper-button-]');
// Swiperのインスタンスを格納する配列
const SWIPER_INSTANCES = [];
// 自動再生時間
const AUTO_DELAY_TIME = 5000;

/** ========================
 * Swiper発火用セレクタ
 * 複数ある場合のSwiper要素のセレクタを配列で定義（js-swiper-xxxのxxxにあたるセレクタ）
 * ========================== */
const TRIGGER_SELECTORS = [ 'post' ];
const slider__items = document.querySelector( '.swiper-wrapper' );

/** ========================
 * Swiperオプション
 * ========================== */
const SWIPER_OPTIONS = {
	//TRIGGER_SELECTORSの配列に入れた値をキーにする
	post: {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 24,
		grabCursor: true,
		navigation: {
			nextEl: '',
			prevEl: '',
		},
		slideClass: 'wp-block-post',
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},

		//mousewheel: true,
		on: {},
		breakpoints: {
			// 以上
			1024: {
				spaceBetween: 40,
				slidesPerGroup: 2,
				slidesPerView: 2,
			},
			600: {
				spaceBetween: 24,
				slidesPerGroup: 2,
				slidesPerView: 2,
			},
		},
	},
};
// スライドの左側の余白slidesOffsetBeforeを計算する関数
function _calcSlidesOffset() {
	const container = document.querySelector( '.js-swiper-post' );
	if ( container ) {
		const containerWidth = container.clientWidth; // コンテナの幅を取得
		const offsetPercentage = 0; // スライドコンテナの幅に対するオフセットの割合
		const offsetPixels = containerWidth * ( offsetPercentage / 100 ); // スライドコンテナの幅に対するオフセットのピクセル値

		console.log( containerWidth );
		console.log( offsetPixels );

		return offsetPixels;
	}
	return 0;
}
/** ========================
 * Swiper初期化
 * ========================== */
function fnc_initializeSwiper() {
	// TRIGGER_SELECTORSの各要素に対してSwiperを初期化し、インスタンスを配列に格納
	TRIGGER_SELECTORS.forEach( ( selector, index ) => {
		const hasTriggers = document.querySelectorAll(
			`.js-swiper-${ selector }`
		);
		if ( hasTriggers.length === 0 ) {
			return; // セレクタが存在しない場合は処理中止
		}

		//navigationとpaginationのセレクタ・設定を格納
		const options = SWIPER_OPTIONS[ selector ];

		if ( options ) {
			const swiperPagination = document.querySelector(
				`.swiper-pagination.-${ selector }`
			);
			if ( swiperPagination ) {
				options.pagination = {
					el: swiperPagination,
					type: options.pagination.type,
					clickable: options.pagination.clickable,
				};
			}

			options.navigation = {
				nextEl: `.swiper-button-next.-${ selector }`,
				prevEl: `.swiper-button-prev.-${ selector }`,
			};

			const swiper = new Swiper( `.js-swiper-${ selector }`, options );
			SWIPER_INSTANCES.push( swiper );

			// console.log(
			// 	`Swiper '.js-swiper-${ selector }' が初期化されました`
			// );
		}
	} );

	//初期化フラグを切り替え
	isSwiperInitialized = true;

	//自動再生時間をcssのvar変数に入れる
	// document.documentElement.style.setProperty(
	// 	'--swiper-auto-delay-time',
	// 	AUTO_DELAY_TIME + 'ms'
	// );
}

/** ========================
 * Swiper読み込み前のガクつき回避
 * ========================== */
// function fnc_swiperHide() {
//     if ($SWIPER_ELEMENTS.length) {
//         $SWIPER_ELEMENTS.css({opacity: 0});
//     }
// }

// // Swiperの初期化が完了した後に要素の表示をアニメーションさせる
// function fnc_swiperFadeIn() {
//     if (isSwiperInitialized && $SWIPER_ELEMENTS.length) {
//         $SWIPER_ELEMENTS.animate({opacity: 1}, 800, 'swing');
//     }
// }

/** ========================
 * リサイズ時処理（あれば）
 * ========================== */
function fnc_handleResize() {
	let resizeTimer;
	window.addEventListener( 'resize', () => {
		if ( resizeTimer ) {
			clearTimeout( resizeTimer );
		}
		resizeTimer = setTimeout( () => {
			// リサイズ時の処理あれば
		}, 200 );
	} );
}

/** ========================
 * 実行
 * ========================== */
window.addEventListener(
	'DOMContentLoaded',
	() => {
		//fnc_swiperHide();
	},
	false
);

window.addEventListener(
	'load',
	() => {
		fnc_initializeSwiper();
		//fnc_swiperFadeIn();
		fnc_handleResize();
	},
	false
);
